<template>
    <div class="modal fade" id="customer_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Customer's Orders History</h4>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-lg-6">
                    <div class="form-group">
                        <label >Customer Name</label>
                        <input readonly :value="customerName" type="text" class="form-control" placeholder="Customer Name">
                    </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label >Customer's Orders Count</label>
                                <input readonly :value="orders.length" type="text" class="form-control">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                <div class="sk-bounce1"></div>
                                <div class="sk-bounce2"></div>
                                <div class="sk-bounce3"></div>
                            </div>
                        </div>
                    </div>

                <div class="table-responsive" style="overflow: auto">
                    <table class="table table-striped table-bordered table-hover responsive" id="dtTable">
                        <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Restaurant</th>
                            <th>Branch</th>
                            <th>Customer Area</th>
                            <th>City</th>
                            <th>Total Amount</th>
                            <th>Order Date</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="order in orders" :key="order.id" >
                            <th>{{ order.orderId }}</th>
                            <td>{{ order.restaurantName }}</td>
                            <td>{{ order.branchName }}</td>
                            <td>{{ order.address}}</td>
                            <td>{{ order.cityName }}</td>
                            <td>{{ order.totalAmount }}</td>
                            <td>{{ order.orderCreated }}</td>

                        </tr>

                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    export default {
        name: "CustomerDetails",
        data: function () {
            return {
                orders:[],
                customerName:"",
                isHideSpinner: "",
            };
        },
        mounted: function () {
            $(this.$refs.modal).on("hidden.bs.modal",function () {
                this.orders=null;
            });
        },
        methods: {
            load: function (customerId,customerName,start,end,restaurant_id,branch_id,city_id) {
              this.customerName=customerName;
                this.orders=[];
                this.isHideSpinner="";
                let params = new URLSearchParams();
                params.append("customer_id", customerId);
                params.append("start", start);
                params.append("end", end);
                params.append("restaurant_id", restaurant_id);
                params.append("branch_id", branch_id);
                params.append("city_id", city_id);
                this.$http.post(this.$store.state.mainAppURL + "dashboard/get_customer_order_details", params).then(resp => {
                  this.isHideSpinner = "hide";
                  this.orders = resp.data.body;
                  this.orders.forEach((item) => {
                      item.orderCreated = this.$moment.parseZone(String(item.orderCreated)).local().format('DD/MM/YYYY hh:mm:ss A');
                  });
              });
              $("#customer_modal").modal("show");
            }
        }

    }
</script>

<style scoped>
@media screen and (min-width: 768px) {
    .modal-dialog {
        width: 800px; /* New width for default modal */
        min-height: 800px !important;
    }
    .modal-content {
        /* 90% of window height */
        min-height: 90%;
    }
}
</style>
